import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const FilterPanel = ({ filters, onFilterChange, onReset, onSaveView }) => {
  const productionLineOptions = [
    { value: 'all', label: 'All Lines' },
    { value: 'line-1', label: 'Assembly Line 1' },
    { value: 'line-2', label: 'Assembly Line 2' },
    { value: 'line-3', label: 'Assembly Line 3' },
    { value: 'line-4', label: 'Sub-Production Line A' },
    { value: 'line-5', label: 'Sub-Production Line B' }
  ];

  const shiftOptions = [
    { value: 'all', label: 'All Shifts' },
    { value: 'day', label: 'Day Shift (6AM-2PM)' },
    { value: 'evening', label: 'Evening Shift (2PM-10PM)' },
    { value: 'night', label: 'Night Shift (10PM-6AM)' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Statuses' },
    { value: 'operational', label: 'Operational' },
    { value: 'warning', label: 'Warning' },
    { value: 'critical', label: 'Critical' },
    { value: 'offline', label: 'Offline' }
  ];

  const severityOptions = [
    { value: 'all', label: 'All Severities' },
    { value: 'critical', label: 'Critical Only' },
    { value: 'warning', label: 'Warning & Above' },
    { value: 'info', label: 'Info & Above' }
  ];

  return (
    <div className="bg-card rounded-xl border-2 border-border p-4 md:p-5 lg:p-6">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <div className="flex items-center gap-2 md:gap-3">
          <Icon name="Filter" size={24} color="var(--color-primary)" />
          <h2 className="text-lg md:text-xl font-semibold text-foreground">
            Filters & Views
          </h2>
        </div>
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            iconName="RotateCcw"
            onClick={onReset}
          >
            <span className="hidden sm:inline">Reset</span>
          </Button>
          <Button
            variant="primary"
            size="sm"
            iconName="Save"
            onClick={onSaveView}
          >
            <span className="hidden sm:inline">Save View</span>
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Select
          label="Production Line"
          options={productionLineOptions}
          value={filters?.productionLine}
          onChange={(value) => onFilterChange('productionLine', value)}
        />

        <Select
          label="Shift Schedule"
          options={shiftOptions}
          value={filters?.shift}
          onChange={(value) => onFilterChange('shift', value)}
        />

        <Select
          label="Area Status"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
        />

        <Select
          label="Alert Severity"
          options={severityOptions}
          value={filters?.severity}
          onChange={(value) => onFilterChange('severity', value)}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <Input
          label="Search Areas"
          type="search"
          placeholder="Search by area name or task..."
          value={filters?.searchQuery}
          onChange={(e) => onFilterChange('searchQuery', e?.target?.value)}
        />

        <div className="flex items-end gap-2">
          <Input
            label="Min Completion %"
            type="number"
            placeholder="0"
            min="0"
            max="100"
            value={filters?.minCompletion}
            onChange={(e) => onFilterChange('minCompletion', e?.target?.value)}
            className="flex-1"
          />
          <Input
            label="Max Completion %"
            type="number"
            placeholder="100"
            min="0"
            max="100"
            value={filters?.maxCompletion}
            onChange={(e) => onFilterChange('maxCompletion', e?.target?.value)}
            className="flex-1"
          />
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-2 mt-4 pt-4 border-t border-border">
        <span className="caption text-muted-foreground">Quick Views:</span>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onFilterChange('quickView', 'critical-only')}
        >
          Critical Only
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onFilterChange('quickView', 'behind-schedule')}
        >
          Behind Schedule
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onFilterChange('quickView', 'current-shift')}
        >
          Current Shift
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onFilterChange('quickView', 'high-throughput')}
        >
          High Throughput
        </Button>
      </div>
    </div>
  );
};

export default FilterPanel;